/**
 * Gives deferred pictures (snippets/ss-defer-image.liquid) back their
 * srcset/src once they come within 400px of the screen. Pictures that are
 * display: none never intersect, so they are never fetched.
 */
(function () {
  if (window.__ssDeferImage) return;
  window.__ssDeferImage = true;

  function show(img) {
    if (img.dataset.ssSrcset) img.srcset = img.dataset.ssSrcset;
    if (img.dataset.ssSrc) img.src = img.dataset.ssSrc;
    img.removeAttribute('data-ss-srcset');
    img.removeAttribute('data-ss-src');
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          show(entry.target);
        });
      }, { rootMargin: '400px 0px' })
    : null;

  function scan() {
    document.querySelectorAll('img[data-ss-srcset], img[data-ss-src]').forEach(function (img) {
      if (img.dataset.ssWatched) return;
      img.dataset.ssWatched = '1';
      if (io) io.observe(img);
      else show(img);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // Theme editor: sections re-render.
  document.addEventListener('shopify:section:load', scan);
})();
